export const pt = {
    confirming: `Confirmando sua conta...`,
    status: `Status da confirmação`,
    waiting: `Por favor aguarde enquanto confirmamos sua conta...`,
    error: `Falha na confirmação da conta. Por favor tente novamente ou contate o suporte.`,
};
//# sourceMappingURL=pt.js.map